import React, { useEffect, useState } from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import { TemplateRenderer } from 'PDF/TemplateEngine';
import { useTenantData } from 'providers/Tenant/TenantDataProvider';
import { getMockData } from './mockData';

function TemplatePreview({ template }) {
  const { tenant } = useTenantData() || {};
  const [debouncedTemplate, setDebouncedTemplate] = useState(template);

  useEffect(() => {
    const id = setTimeout(() => setDebouncedTemplate(template), 500);
    return () => clearTimeout(id);
  }, [template]);

  if (!debouncedTemplate) return null;

  const data = getMockData(debouncedTemplate.documentType);
  const config = tenant || {};

  return (
    <PDFViewer
      style={{ width: '100%', height: '100%', border: 'none' }}
      showToolbar={false}
    >
      <TemplateRenderer template={debouncedTemplate} data={data} config={config} />
    </PDFViewer>
  );
}

export default TemplatePreview;
